/* eslint-disable max-lines-per-function */
import React from "react";
import { IconButton, InputAdornment, styled, TextField, Tooltip } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ResetSearchIcon from "@material-ui/icons/Clear";
import { useSidebarFilters } from "../sidebar-filters";

const CustomTextField = styled(TextField)(() => ({
  "& .MuiInputBase-input": {
    fontWeight: "400 !important", // This is to override bootstrap nonsense
  },
  "& .MuiInputLabel-root": {
    fontWeight: "400 !important", // This is to override bootstrap nonsense
  },
}));

const SearchBox: React.FC = () => {
  const { setTextFilter, textFilter } = useSidebarFilters();
  const [value, setValue] = React.useState(textFilter);
  const setFilter = (filter:string) => {
    setValue(filter);
    setTextFilter(filter.trim());
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };
  return (
    <CustomTextField
      onChange={handleChange}
      placeholder="Search"
      autoComplete="off"
      value={value}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Tooltip title="Search">
              <SearchIcon fontSize="small" />
            </Tooltip>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              disabled={!value}
              onClick={() => setFilter("")}
              aria-label="Clear Search"
            >
              <ResetSearchIcon
                fontSize="small"
                aria-label="clear"
              />
            </IconButton>
          </InputAdornment>
        ),
        inputProps: {
          "aria-label": "Clear Search",
          "data-cy": "search-box",
        },
      }}
      style={{ paddingLeft: 8, paddingRight: 8 }}
    />
  );
};


export default SearchBox;
